import * as THREE from 'three';
//import THREE from 'THREE_BOOTSTRAP';  //This causes problems
import earthTexture1 from "./earthmap1k.jpg";
import earthTexture2 from "./earth-blank.png";
import earthTexture3 from "./earthmap4kc.jpg"; // Compressed with TinyPNG
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import { Mesh } from 'three';
import DropinSupervisorBase from "SATPROF_LIBRARY/DropinSupervisor/dropin-supervisor-base";
import ThreeFontService from "SATPROF_LIBRARY/DropinSupervisor/services/three-font-service";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import Tree2_grp from "SATPROF_LIBRARY/ThreeDParts/Tree2_grp";
import House_grp from "SATPROF_LIBRARY/ThreeDParts/House_grp";
import PolyLine_grp from "SATPROF_LIBRARY/ThreeDParts/PolyLine_grp";
import String3D_grp from 'SATPROF_LIBRARY/ThreeDParts/String3D_grp';
import ArcLine_grp from 'SATPROF_LIBRARY/ThreeDParts/ArcLine_grp';

//import SphericalSectionGeometry_geom from "SATPROF_LIBRARY/ThreeDParts/SphericalSectionGeometry_geom";
export default class Earth1_grp  extends THREE.Group{
   /*
    +Y is through north pole.
    X-Z is the plane of the equator.
    +X is through the prime meridian (longitude = 0)
    +Z is through longitude -90E

    Properties and methods
    siteLong    Longitude of the site on the equator that generators the beam
    beamScanAngle   Left/right from zenith for the beam from the equator site
    showBeam
    beamStyle   "cone" "disc"
    showBeamContourLines    This is independend of the two beams
    beamAz
    beamEl


    showLatLines
    showLongLines
    showLatTexts
    showLongTexts
    latList
    longList
    longLineColor
    PMColor
    latLineColor
    equatorColor
    siteLat
    siteLong
    showCursors
    cursorLineLineColor
    textureNo   1 = earthmap1k.jpg, 2 = earth-blank.png, 3 = earthmap4k.jpg

    */
    public earth_g:THREE.SphereGeometry;
    public earth_mat:THREE.MeshPhongMaterial;
    public earth_m:THREE.Mesh;
    private _beamScanAngle:number = 0;
    public beam1:THREE.Group
    public beamHolderAz:THREE.Group;
    public beamHolderEl:THREE.Group; 
    private _beamAz:number = 0;
    private _beamEl:number = 0;   
    private _beamHB3:number = 1;
    private _beamLength_km:number = 40000;
    public beam2:THREE.Group;
    public beamDisc1_g:THREE.CircleGeometry
    public beamDisc2_g:THREE.CircleGeometry
    public beamDisc3_g:THREE.CircleGeometry;
    public beamDisc1_m:Mesh;    
    public beamDisc2_m:Mesh;    
    public beamDisc3_m:Mesh;    
    public discMat1:THREE.MeshPhongMaterial
    public discMat2:THREE.MeshPhongMaterial
    public discMat3:THREE.MeshPhongMaterial
    public beamContourLines:THREE.Group;
    public beamContourLine1:PolyLine_grp
    public beamContourLine2:PolyLine_grp
    public beamContourLine3:PolyLine_grp
    private _showBeamContourLines:boolean = false;
    private _showBeamDiscs:boolean = true;
    private _beam_El_over_Az_BW_ratio:number = 1;

    private _beamStyle:string; // "cone" "disc"
    private ellipse:THREE.Group;
    private latlines:THREE.Group;
    private longlines:THREE.Group;
    private latTexts:THREE.Group;
    private longTexts:THREE.Group;
    private cursors:THREE.Group;
    private _siteLatDeg:number = 10;
    private _siteLongDeg:number = 0;
    //private latCursor_line:THREE.Line;
    //private latCursor_pl:PolyLine_grp;
    private latCursor_arcline:ArcLine_grp;
    //private longCursor_line:THREE.Line;
    //private longCursor_pl:PolyLine_grp;
    private longCursor_arcline:ArcLine_grp;
    private _latCursorLineLineColor:string = "red";
    private _lonCursorLineLineColor:string = "green";
    public siteSphere_m:THREE.Mesh;
    public sitePosEarthFrame:THREE.Vector3;
    public supervisor:DropinSupervisorBase;
    public threeFontService:ThreeFontService;
    private globeSegments:number = 360;
    private _latList:Array<number>;
    private _longList:Array<number>;
    private _longLineLineColor:string = "lime";
    private _primeMeridianLineColor:string = "lime";
    private _latLineLineColor:string = "red";
    private _equatorLineColor:string = "red";
    private mainRadius:number;
    private cursorRadius:number;
    private blinkTimer:TimingInfo;
    private _siteBlink:boolean = true;
    private _siteSize:number = 150;
    private _siteColor:string = "yellow";

    public sitePlatform1_grp:THREE.Group;
    public sitePlatform2_grp:THREE.Group;
    public sitePlatform_grp:THREE.Group;
    public camHolder:THREE.Group;
    //public sitePlatform_m:THREE.Mesh;
    private _showSiteSphere:boolean = false;
    private _groundTrackLon:number = 0;
    private groundTrackRadius:number = UtilSP.geoRadiuskm;
    private groundTrackLine_pl:PolyLine_grp;
    private cone1_m:THREE.Mesh;
    private cone2_m:THREE.Mesh;
    private cone3_m:THREE.Mesh;
    private _fixedSitesName:Array<string>;
    private _fixedSitesLat:Array<number>;
    private _fixedSitesLong:Array<number>;
    private _fixedSiteColor:Array<string>;
    private _fixedSiteSize:Array<number>;
    private _fixedSiteVisible:Array<boolean>;
    private _maxFixedSites:number = 50;
    private _fixedSite_g:Array<THREE.SphereGeometry>;
    private _fixedSite_mat:Array<THREE.MeshBasicMaterial>;
    private _fixedSite_m:Array<THREE.Mesh>;
    private _fixedSiteDisc_grp1:Array<THREE.Group>;
    private _fixedSiteDisc_grp2:Array<THREE.Group>;
    //private _fixedSiteDisc_m:Array<THREE.Mesh>;
    //private _fixedSiteDisc_g:Array<SphericalSectionGeometry_geom>;
    //private _fixedSiteDisc_mat:Array<THREE.MeshPhongMaterial>;
    private _fixedSiteDiscVisible:Array<boolean>;
    private _fixedSiteRing_p:Array<THREE.Vector3>;
    // private _fixedSiteRing_g:Array<THREE.Geometry>;
    // private _fixedSiteRing_mat:Array<THREE.LineBasicMaterial>;
    // private _fixedSiteRing_l:Array<THREE.Line>;
    private _fixedSiteRing_pl:Array<PolyLine_grp>;


    private _showFixedSites:boolean;

    constructor(){
        super();
        //console.log("In Earth1_grp constructor...")

        this.supervisor = DropinSupervisorBase.singleton; // Needed for 3D text
        // get the service - this also casts the service to the right class
        // this way it should be accessible from anywhere
         this.threeFontService = this.supervisor.getService<ThreeFontService>("ThreeFontService");
        //debugger;

        this.earth_g = new THREE.SphereGeometry(UtilSP.earthRadiuskm, this.globeSegments, this.globeSegments); // radius in km
        //var material = new THREE.MeshBasicMaterial({color:0x0000FF} );
        this.earth_mat = new THREE.MeshPhongMaterial( );

        //this.earth_mat.map = new THREE.TextureLoader().load( earthTexture1 );  // works
        //this.earth_mat.map = new THREE.TextureLoader().load( earthTexture2 );  

        this.earth_m = new THREE.Mesh(this.earth_g, this.earth_mat);
        //console.log("material.color = "+this.material.color);
        
        // Make the beam with nominals
        // All these will get changed in updateBeam
 
        this.cone1_m = new Mesh();
        this.cone2_m = new Mesh();
        this.cone3_m = new Mesh();
    
        this.beam1 = new THREE.Group;
      
        this.beam1.add(this.cone1_m, this.cone2_m, this.cone3_m);

        // Make the disc style beam (spot)
        this.beam2 = new THREE.Group;

        this.beamDisc1_m = new Mesh();
        this.beamDisc2_m = new Mesh();
        this.beamDisc3_m = new Mesh();

        this.beam2.add(this.beamDisc1_m, this.beamDisc2_m, this.beamDisc3_m);

        this.beamContourLines  = new THREE.Group();

        this.beamContourLine1 = new PolyLine_grp();
        this.beamContourLine2 = new PolyLine_grp();
        this.beamContourLine3 = new PolyLine_grp();
        this.beamContourLines.add(this.beamContourLine1, this.beamContourLine2, this.beamContourLine3);


        this._beamLength_km = UtilSP.geoHeightkm
        this.updateBeam();
        //this.beam1.position.x = UtilSP.earthRadiuskm;
 
        //this.beam2 = new THREE.Group;
        //this.beam2.rotation.y = UtilSP.radians(this._siteLongDeg);
        //this.beam2.add(this.beam1);
        //this.add( this.beam2  );     
        this.add( this.earth_m  );     


        // Make lat and long cursors
        this.mainRadius = UtilSP.earthRadiuskm * 1.01;
        this.cursorRadius = UtilSP.earthRadiuskm * 1.02;

        this._latList = [];
        this.latlines = new THREE.Group;
        this.add( this.latlines  );    
        this.latlines.visible = false;
        this.latTexts = new THREE.Group;
        this.add( this.latTexts  );   
        this.latTexts.visible = true;
        this.makeLatlines();


        this._longList = [0,30,60,90,120,150,180,210,240,270,300,330];
        this.longlines = new THREE.Group;
        this.add( this.longlines  );          
        this.longlines.visible = false;
        this.longTexts = new THREE.Group;
        this.add( this.longTexts  );   
        this.longTexts.visible = true;
        this.makeLonglines();

        this.cursors = new THREE.Group;
        this.add( this.cursors );  
        this.cursors.visible = true;
        this.makeCursors();

        this.makeGroundTrackLine()
        this.groundTrackLine_pl.visible = false;

        //  this
        //     sitePlatform1_grp
        //          sitePlatform2_grp
        //              sitePlatform_grp
        //                  village_grp
        //                  camHolder
        //                  siteSphere_m

        this.sitePlatform1_grp = new THREE.Group();
        this.sitePlatform2_grp = new THREE.Group();
        this.sitePlatform_grp = new THREE.Group();
        this.add(this.sitePlatform1_grp);
        this.sitePlatform1_grp.add(this.sitePlatform2_grp);
        this.sitePlatform2_grp.add(this.sitePlatform_grp);
        this.sitePosEarthFrame= new THREE.Vector3(0,0,0);

        // Put our little town here in sitePlatform_grp
        let village_grp:THREE.Group = new THREE.Group();

        let scalefactor:number = 0.001; // Houses are in meters, earth is in km  But .001 doesn't render well  
        let trees:Array<Tree2_grp> = [];
        let houses:Array<House_grp> = [];
        let treeDist:Array<number> = [100,100,100,100,100,100,100,100,];
        let treeAz:Array<number> = [0, 90, 180, 270, 40, 130, 210,290];
        let treeHeight:Array<number> = [10,7, 7, 7, 4, 4, 4,4];

        let houseDist:Array<number> = [80, 120, 80, 120, 50, 120, 120,80,90,80, 80, 120, 80, 50, 120, 120, 70];
        let houseAz:Array<number> = [20, 30, 75, 110, 140, 155, 190, 230, 245, 265, 5, 28, 93, 280, 340, 305, 189, 175, 202, 10];
        let houseWidth:Array<number> = [3,9,7,5,3,8,7,4,6,3, 4,2,3,6,4,7,3,2,3,5];
        let houseHeight:Array<number> = [10,8,15,3,8,5,9,12,4,10, 5,9,12,4,10,8,15,3,8,5];
        let houseWallColor:Array<string> = 
            ["white","brown","red","yellow","blue","red","yellow","white","brown","blue",
            "red","yellow","white","white","brown","blue","white","brown","red","yellow" ];
        let houseRoofColor:Array<string> = 
            ["red","yellow","white","brown","yellow","white","brown","red","yellow","red",
            "brown","blue","white","brown","red","yellow","white","brown","brown","blue"];
        let i:number;
        for (i=0; i<treeDist.length; i++){
            trees[i] = new Tree2_grp();
            trees[i].position.x = treeDist[i]*Math.cos(UtilSP.radians(treeAz[i]));
            trees[i].position.z = treeDist[i]*Math.sin(UtilSP.radians(treeAz[i]));
            //trees[i].scale.set(scalefactor, scalefactor, scalefactor);
            village_grp.add(trees[i]);
        }
         for (i=0; i<houseDist.length; i++){
            houses[i] = new House_grp();
            houses[i].position.x = houseDist[i]*Math.cos(UtilSP.radians(houseAz[i]));
            houses[i].position.z = houseDist[i]*Math.sin(UtilSP.radians(houseAz[i]));
            houses[i].wallColor = houseWallColor[i];
            houses[i].roofColor = houseRoofColor[i];
            houses[i].houseWidth = houseWidth[i];
            houses[i].houseHeight = houseHeight[i];
            //houses[i].scale.set(scalefactor, scalefactor, scalefactor);
            village_grp.add(houses[i]);
        }   
        let villageGround_g:THREE.CircleGeometry = new THREE.CircleGeometry(5100,36); // 5.1km is horizon distance for 6m

        const billboardlabelConfig = this.threeFontService.getGeometryConfigObject();
        billboardlabelConfig.size = 20;
        let billboardColor:string = "black";

        let billboardSouth_g = this.threeFontService.createFontGeometry("S", billboardlabelConfig);
        let billboardSouth_m = new THREE.Mesh(billboardSouth_g, new THREE.MeshBasicMaterial({color:billboardColor}));//THREE.MeshPhongMaterial
        billboardSouth_m.position.x = 200;
        billboardSouth_m.position.y = 40;
        billboardSouth_m.rotation.y = -Math.PI/2;

        let billboardNorth_g = this.threeFontService.createFontGeometry("N", billboardlabelConfig);
        let billboardNorth_m = new THREE.Mesh(billboardNorth_g, new THREE.MeshBasicMaterial({color:billboardColor}));//THREE.MeshPhongMaterial
        billboardNorth_m.position.x = -200;
        billboardNorth_m.position.y = 40;
        billboardNorth_m.rotation.y = Math.PI/2;

        let billboardEast_g = this.threeFontService.createFontGeometry("E", billboardlabelConfig);
        let billboardEast_m = new THREE.Mesh(billboardEast_g, new THREE.MeshBasicMaterial({color:billboardColor}));//THREE.MeshPhongMaterial
        billboardEast_m.position.z = -200;
        billboardEast_m.position.y = 40;
        billboardEast_m.rotation.y = 0;

        let billboardWest_g = this.threeFontService.createFontGeometry("W", billboardlabelConfig);
        let billboardWest_m = new THREE.Mesh(billboardWest_g, new THREE.MeshBasicMaterial({color:billboardColor}));//THREE.MeshPhongMaterial
        billboardWest_m.position.z = 200;
        billboardWest_m.position.y = 40;
        billboardWest_m.rotation.y = Math.PI;

        village_grp.add(billboardSouth_m, billboardNorth_m, billboardEast_m, billboardWest_m);

        let villageGround_mat = new THREE.MeshPhongMaterial({color:"tan", side: THREE.DoubleSide} );
        let villageGround_m:THREE.Mesh = new THREE.Mesh(villageGround_g,villageGround_mat);
        village_grp.scale.set(scalefactor, scalefactor, scalefactor);
        village_grp.add(villageGround_m);
        villageGround_m.position.z = 0;
        villageGround_m.rotation.x = -Math.PI/2;

        //this.camHolder.position.z = 30000;

        this.sitePlatform_grp.add(village_grp);
        this.camHolder = new THREE.Group();
        this.sitePlatform_grp.add( this.camHolder);


        this.beamHolderAz = new THREE.Group();
        this.beamHolderEl = new THREE.Group();

        this.sitePlatform_grp.add(this.beamHolderAz);
        this.beamHolderAz.add(this.beamHolderEl);
        this.beamHolderEl.add(this.beam1, this.beam2, this.beamContourLines);

        //let beamHelper:THREE.AxesHelper = new THREE.AxesHelper( 5000 );
        //this.beamHolderEl.add( beamHelper );

        //let platformHelper:THREE.AxesHelper = new THREE.AxesHelper( 5000 );
        //this.sitePlatform_grp.add( platformHelper );

        //Make sphere to be put at the site location
        let siteSphere_g = new THREE.SphereGeometry(this._siteSize, 8, 8); // radius in km
        let siteSphere_mat = new THREE.MeshBasicMaterial({color:this._siteColor} );
        this.siteSphere_m = new THREE.Mesh(siteSphere_g, siteSphere_mat);
        this.siteSphere_m.position.y = 75; ///1000;
        this.sitePlatform_grp.add(this.siteSphere_m);
        this.sitePlatform_grp.rotation.z = -Math.PI/2;
        this.blinkTimer = new TimingInfo();
        this.blinkTimer.reset();

        // Now use setters to set defaults:
        this.siteLong = 0; 
        this.beamScanAngle = 0;
        this.showBeam = true;

        this.showLatLines = false;
        this.showLongLines = false;
        this.showLatTexts = false;
        this.showLongTexts = false;
        this.latList = [-90, -75, -60, -45, -30, -15, 0, 15, 30, 45, 60, 75, 90];
        this.longList = [0,30,60,90,120,150,180,210,240,270,300,330];
        this.longLineColor = "lime";
        this.PMColor = "lime";
        this.latLineColor = "red";
        this.equatorColor = "red";
        this.siteLat = 0;
        this.siteLong = 0;
        this.showCursors  = false;  
        this.latCursorLineLineColor = "red"; 
        this.lonCursorLineLineColor = "red"; 

        this.updateSite();
 
        this.initializeFixedSites();
        //let axesHelper:THREE.AxesHelper = new THREE.AxesHelper( 500000 );
       // this.add( axesHelper );
    }
    private makeCursors(){
        this.cursors.children = []; // .clear() doesn't seem to be recognized

        this.latCursor_arcline = new ArcLine_grp();
        this.latCursor_arcline.nPoints = this.globeSegments;
        this.latCursor_arcline.angle = 360;
        this.latCursor_arcline.color = this.latCursorLineLineColor;
        this.latCursor_arcline.lineWidth = 2;
        this.latCursor_arcline.radius = this.cursorRadius;
        this.latCursor_arcline.rotation.x = Math.PI/2;
        this.cursors.add(this.latCursor_arcline);

        this.longCursor_arcline = new ArcLine_grp();
        this.longCursor_arcline.nPoints = this.globeSegments;
        this.longCursor_arcline.angle = 360;
        this.longCursor_arcline.lineWidth = 2;
        //this.longCursor_pl.points = pointsLong;
        this.longCursor_arcline.color = this._lonCursorLineLineColor;
        this.longCursor_arcline.radius = this.cursorRadius;
        this.cursors.add(this.longCursor_arcline);
    }
    private updateSite(){
        //console.log("In Earth1_grp.updateSite, lat = "+this._siteLatDeg+", beamEl = "+this.beamEl);
        let latRad:number = UtilSP.radians(this._siteLatDeg);
        let longRad:number = UtilSP.radians(this._siteLongDeg);
        this.latCursor_arcline.position.y = this.cursorRadius*Math.sin(latRad);
        this.latCursor_arcline.radius = this.cursorRadius * Math.cos(latRad);
        this.longCursor_arcline.rotation.y = longRad;

        //this.siteSphere_m.position.setFromSphericalCoords(this.cursorRadius, Math.PI/2-latRad, longRad+Math.PI/2);

        this.sitePlatform_grp.position.x = UtilSP.earthRadiuskm;
        this.sitePlatform1_grp.rotation.y = longRad; //UtilSP.radians(30); // Long
        this.sitePlatform2_grp.rotation.z = latRad; //UtilSP.radians(10); // Lat 

        this.beamHolderAz.rotation.y = UtilSP.radians(-this._beamAz - 180);
        this.beamHolderEl.rotation.z = UtilSP.radians(this._beamEl);

        /* private update(){
        this.beam2.rotation.y = UtilSP.radians(this._siteLong);
        this.beam1.rotation.y = UtilSP.radians(this._beamScanAngle);
        }  
        */   
       
        this.sitePosEarthFrame.setFromSphericalCoords(UtilSP.earthRadiuskm, Math.PI/2 - latRad, longRad + Math.PI/2);

        this.updateBeam();

    }
    private updateSiteAppearance(){
        let siteSphere_g = new THREE.SphereGeometry(this._siteSize, 8, 8); // radius in km
        let siteSphere_mat = new THREE.MeshBasicMaterial({color:this._siteColor} );
        this.siteSphere_m.geometry = siteSphere_g;
        this.siteSphere_m.material = siteSphere_mat;
        this.siteSphere_m.position.y = this._siteSize/2;
    }
    private makeLatlines(){
        this.latlines.children = []; // .clear() doesn't seem to be recognized
        this.latTexts.children = []; // .clear() doesn't seem to be recognized

        let latDeg:number;
        let latline_arcline:Array<ArcLine_grp> = [];
        const labelConfig = this.threeFontService.getGeometryConfigObject();
        labelConfig.size = 500;
        const labelColor:string = "yellow";
        // let latText_g:Array<THREE.Geometry> = [];
        // let latText_m:Array<THREE.Mesh> = [];
        let latText_grp:Array<THREE.Group> = [];
        let latText_str:Array<String3D_grp> = [];

 
        for (let i:number=0; i<this._latList.length; i++){
            latDeg = this._latList[i];
            latline_arcline[i] = new ArcLine_grp();
            latline_arcline[i].radius = this.mainRadius
            latline_arcline[i].lineWidth = 2;
            latline_arcline[i].angle = 360;
            latline_arcline[i].nPoints = this.globeSegments;                    
            if (latDeg == 0){
                latline_arcline[i].color = this._equatorLineColor;
            } else {
                latline_arcline[i].color = this._latLineLineColor;
            }
            latline_arcline[i].rotation.x = Math.PI/2;
            latline_arcline[i].position.y = this.mainRadius*Math.sin(UtilSP.radians(latDeg));
            latline_arcline[i].radius = this.mainRadius*Math.cos(UtilSP.radians(latDeg))
            this.latlines.add(latline_arcline[i]);

            let thisLatText:string;
            if (latDeg < 0){
                thisLatText = String(-latDeg) + "°S";
            } else if (latDeg > 0){
                thisLatText = String(latDeg) + "°N";
            } else {
                thisLatText = "0° (equator)";
            }

            //latText_g[i] = this.threeFontService.createFontGeometry(thisLatText, labelConfig);
            //latText_m[i] = new THREE.Mesh(latText_g[i], new THREE.MeshBasicMaterial({color:labelColor}));//THREE.MeshPhongMaterial
            latText_str[i] = new String3D_grp();
            latText_str[i].color = labelColor;
            latText_str[i].text = thisLatText;
            latText_str[i].lineHeight = 300;           

            latText_grp[i] = new THREE.Group;
            this.latTexts.add(latText_grp[i]);
            //latText_grp[i].add(latText_m[i]);
            latText_grp[i].add( latText_str[i]);
            //latText_g[i].computeBoundingBox();
            //let textWidth = latText_g[i].boundingBox.max.x - latText_g[i].boundingBox.min.x;
            let textHeight = latText_str[i].boundingBox.max.y - latText_str[i].boundingBox.min.y;
            let textWidth = latText_str[i].boundingBox.max.x - latText_str[i].boundingBox.min.x;

            //console.log("thisLatText = "+thisLatText+", textWidth = "+textWidth);
            latText_str[i].position.z = textWidth/2;
            latText_str[i].position.y = -textHeight/2;
            latText_str[i].rotation.y = Math.PI/2;
            latText_grp[i].rotation.z = UtilSP.radians(latDeg);
            latText_grp[i].position.x = this.mainRadius * Math.cos(UtilSP.radians(latDeg));
            latText_grp[i].position.y = this.mainRadius * Math.sin(UtilSP.radians(latDeg));
        }
    }
    private makeLonglines(){
        this.longlines.children = [];
        this.longTexts.children = [];

        let longDeg:number;
        let longline_arcline:Array<ArcLine_grp> = [];
        const labelConfig = this.threeFontService.getGeometryConfigObject();
        labelConfig.size = 700;
        const labelColor:string = "yellow";
        // let longText_g:Array<THREE.Geometry> = [];
        // let longText_m:Array<THREE.Mesh> = [];
        let longText_grp:Array<THREE.Group> = [];
        let longText_str:Array<String3D_grp> = [];

        for (let i:number=0; i<this._longList.length; i++){
            longDeg = this._longList[i];
            longline_arcline[i] = new ArcLine_grp();
            longline_arcline[i].radius = this.mainRadius
            longline_arcline[i].lineWidth = 2;
            longline_arcline[i].angle = 360;
            longline_arcline[i].nPoints = this.globeSegments;
            if (longDeg == 0){
                longline_arcline[i].color =  this._primeMeridianLineColor;
            } else {
                longline_arcline[i].color =  this._longLineLineColor;
            }
            longline_arcline[i].rotation.y = UtilSP.radians(longDeg);
            this.longlines.add(longline_arcline[i]);

            let thisLongText:string;
            if (longDeg < 0){
                thisLongText = String(-longDeg) + "°W";
            } else if (longDeg > 0){
                thisLongText = String(longDeg) + "°E";
            } else {
                thisLongText = "0°";
            }

            //longText_g[i] = this.threeFontService.createFontGeometry(thisLongText, labelConfig);
            //longText_m[i] = new THREE.Mesh(longText_g[i], new THREE.MeshBasicMaterial({color:labelColor}));
            longText_str[i] = new String3D_grp();
            longText_str[i].text = thisLongText;            
            longText_str[i].lineHeight = 300;           
            longText_str[i].color = labelColor;            
            longText_grp[i] = new THREE.Group;
            this.longTexts.add(longText_grp[i]);
            longText_grp[i].add(longText_str[i]);
            //longText_g[i].computeBoundingBox();
            let textWidth = longText_str[i].boundingBox.max.x - longText_str[i].boundingBox.min.x;
            let textHeight = longText_str[i].boundingBox.max.y - longText_str[i].boundingBox.min.y;

            //console.log("thisLatText = "+thisLatText+", textWidth = "+textWidth);
            longText_str[i].position.z = textWidth/2;
            longText_str[i].position.y = -textHeight/2;
            longText_str[i].rotation.y = Math.PI/2;
            longText_str[i].position.x = this.mainRadius;
            longText_grp[i].rotation.y = UtilSP.radians(longDeg);

        }

    }
    private makeGroundTrackLine(){
        
        let lonR:number = UtilSP.radians(this._groundTrackLon);
        let R = this.groundTrackRadius;
        let xx:number = R*Math.cos(lonR);
        let zz:number  = -R*Math.sin(lonR);
        this.groundTrackLine_pl = new PolyLine_grp();
        this.groundTrackLine_pl.quickSet(0,0,0,  R,0,0, "#dddddd", 2);
    }
    private updateGroundTrackLine(){
        this.groundTrackLine_pl.rotation.y = UtilSP.radians(this._groundTrackLon);
    }
    public set beamHB3(val:number){
        this._beamHB3 = val;
        this.updateBeam();
    }
    public get beamHB3(){
        return this._beamHB3;
    }
    private updateBeam(){
        //console.log("In updateBeam");

        // Cone style:
        let hb3:number = this._beamHB3;

        let beamLenCone1:number = 1.2 * this._beamLength_km; //UtilSP.geoHeightkm + 0; // 40000;
        let beamLenCone2:number =  1.1 * this._beamLength_km; //UtilSP.geoHeightkm; // 40000;
        let beamLenCone3:number =  1.0 * this._beamLength_km; //UtilSP.geoHeightkm + 500; // 40000;
        let hb05:number = UtilSP.loss2beamwidth( 0.5, hb3 );
        let hb6:number = UtilSP.loss2beamwidth( 6, hb3 );
        let hb20:number = UtilSP.loss2beamwidth( 20, hb3 );

        let rCone05:number = beamLenCone1 * Math.tan( UtilSP.radians(hb05) );
        let rCone6:number = beamLenCone2 * Math.tan( UtilSP.radians(hb6) );
        let rCone20:number = beamLenCone3 * Math.tan( UtilSP.radians(hb20) );

        // Cones:
        let cone1_g:THREE.ConeGeometry = new THREE.ConeGeometry(rCone05, beamLenCone1, 32);
        let cone2_g:THREE.ConeGeometry = new THREE.ConeGeometry(rCone6,  beamLenCone2, 32);
        let cone3_g:THREE.ConeGeometry = new THREE.ConeGeometry(rCone20, beamLenCone3, 32);

        let coneMat1:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial(
            {color:UtilSP.c2rgba("yellow") , transparent:true, opacity:.5});
        //let coneMat2:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial(
        //    {color:UtilSP.c2rgba("orange"), transparent:true, opacity:0.5});
        let coneMat2:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial(
            {color:UtilSP.c2rgba("orange")});  ////           
        let coneMat3:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial(
            {color:UtilSP.c2rgba("red")}); //, transparent:true, opacity:1

        this.cone1_m.geometry = cone1_g;
        this.cone2_m.geometry = cone2_g;
        this.cone3_m.geometry = cone3_g;
        this.cone1_m.material = coneMat1;
        this.cone2_m.material = coneMat2;
        this.cone3_m.material = coneMat3;

        this.cone1_m.position.x = beamLenCone1/2;
        this.cone2_m.position.x = beamLenCone2/2;
        this.cone3_m.position.x = beamLenCone3/2;
        this.cone1_m.rotation.z = Math.PI/2;
        this.cone2_m.rotation.z = Math.PI/2;
        this.cone3_m.rotation.z = Math.PI/2;   

        // Discs:
        let discop:number = 0.2;
        this.discMat1 = new THREE.MeshPhongMaterial(
            {color:"red", transparent:true, opacity:0.8, side: THREE.DoubleSide}); 
        this.discMat2 = new THREE.MeshPhongMaterial(
            {color:"orange", transparent:true, opacity:discop, side: THREE.DoubleSide});
        this.discMat3 = new THREE.MeshPhongMaterial(
            {color:"yellow", transparent:true, opacity:discop, side: THREE.DoubleSide }); // // purple

        let rDisc05:number = this._beamLength_km * Math.tan( UtilSP.radians(hb05) );
        let rDisc6:number = this._beamLength_km * Math.tan( UtilSP.radians(hb6) );
        let rDisc20:number = this._beamLength_km * Math.tan( UtilSP.radians(hb20) );

        this.beamDisc1_g = new THREE.CircleGeometry(rDisc05, 32)
        this.beamDisc2_g = new THREE.CircleGeometry(rDisc6, 32)
        this.beamDisc3_g = new THREE.CircleGeometry(rDisc20, 32)
        this.beamDisc1_m.geometry = this.beamDisc1_g;
        this.beamDisc2_m.geometry = this.beamDisc2_g;
        this.beamDisc3_m.geometry = this.beamDisc3_g;
        this.beamDisc1_m.material = this.discMat1;
        this.beamDisc2_m.material = this.discMat2;
        this.beamDisc3_m.material = this.discMat3;        

        this.beamDisc1_m.visible = this._showBeamDiscs;
        this.beamDisc2_m.visible = this._showBeamDiscs;
        this.beamDisc3_m.visible = this._showBeamDiscs;

        this.beamDisc1_m.position.x = 0.98 * this._beamLength_km;
        this.beamDisc2_m.position.x = 0.99 * this._beamLength_km;
        this.beamDisc3_m.position.x = this._beamLength_km; 
        this.beamDisc1_m.rotation.y = Math.PI/2;
        this.beamDisc2_m.rotation.y = Math.PI/2;
        this.beamDisc3_m.rotation.y =  Math.PI/2;

        // this.beamDisc1_m.scale.setY(eccentricity);
        // this.beamDisc2_m.scale.setY(eccentricity);
        // this.beamDisc3_m.scale.setY(eccentricity);
        this.beam1.scale.setY(this._beam_El_over_Az_BW_ratio);
        this.beam2.scale.setY(this._beam_El_over_Az_BW_ratio);

        this.beamContourLine1.makeCircle(rDisc05, 36, "yz");
        this.beamContourLine1.lineColor = "red";
        this.beamContourLine1.lineWidth = 2;
        this.beamContourLine1.position.x = this._beamLength_km;

        this.beamContourLine2.makeCircle(rDisc6, 36, "yz");
        this.beamContourLine2.lineColor = "orange";
        this.beamContourLine2.lineWidth = 2;
        this.beamContourLine2.position.x = this._beamLength_km;

        this.beamContourLine3.makeCircle(rDisc20, 36, "yz");
        this.beamContourLine3.lineColor = "yellow";
        this.beamContourLine3.lineWidth = 3;
        this.beamContourLine3.position.x = this._beamLength_km;

        this.beamContourLine1.scale.setY(this._beam_El_over_Az_BW_ratio);
        this.beamContourLine2.scale.setY(this._beam_El_over_Az_BW_ratio);
        this.beamContourLine3.scale.setY(this._beam_El_over_Az_BW_ratio);

        this.beamContourLines.visible = this._showBeamContourLines;

    }


    private initializeFixedSites(){
        let i:number;
        this._fixedSiteDisc_grp1 = [];
        this._fixedSiteDisc_grp2 = [];
        //this._fixedSiteDisc_g = [];
        //this._fixedSiteDisc_mat = [];
        //this._fixedSiteDisc_m = [];
        this._fixedSiteRing_p = [];
        // this._fixedSiteRing_g = [];
        // this._fixedSiteRing_mat = [];
        // this._fixedSiteRing_l = [];
        this._fixedSiteRing_pl = [];

        this._fixedSiteDiscVisible = [];
        let zoneRadius:number = 3770;
        let discR:number;
        let a:number;

        //this._fixedSiteDisc_mat = new THREE.MeshBasicMaterial({color:"red",  side: THREE.DoubleSide});

        this._fixedSitesName = [];
        this._fixedSitesLat = [];
        this._fixedSitesLong = [];
        this._fixedSiteColor = [];
        this._fixedSiteSize = [];
        this._fixedSiteVisible = [];      
        this._fixedSite_g = [];      
        this._fixedSite_mat = [];      
        this._fixedSite_m = [];      
        for (i=0; i<this._maxFixedSites; i++){
            this._fixedSitesName[i] = "Fixed site "+i;
            this._fixedSitesLat[i] = 0;
            this._fixedSitesLong[i] = 0;
            this._fixedSiteColor[i] = "purple";
            this._fixedSiteSize[i] = 50;
            this._fixedSiteVisible[i] = false;
            this._fixedSite_g[i] = new THREE.SphereGeometry(this._fixedSiteSize[i]);
            this._fixedSite_mat[i] = new THREE.MeshBasicMaterial({color:this._fixedSiteColor[i]});
            this._fixedSite_m[i] = new THREE.Mesh(this._fixedSite_g[i], this._fixedSite_mat[i]);
            this.add(this._fixedSite_m[i] );

            discR = UtilSP.earthRadiuskm+50
		    //this._fixedSiteDisc_g[i] = new SphericalSectionGeometry_geom({diameter:2*zoneRadius, sphereRadius:discR, nSegments:32, nRings:32, frontside:false});
            //this._fixedSiteDisc_mat[i] = new THREE.MeshPhongMaterial({color:"blue", transparent:true, opacity:0.5});
            for (let k=0; k<=36; k++){
                a = (k/36)*2*Math.PI;
                this._fixedSiteRing_p.push(new THREE.Vector3( zoneRadius*Math.cos( a ), zoneRadius*Math.sin(a), 0));
            }
            let ringColor:string = "#"+( 256*256*UtilSP.randRangeInt(50,200)+256*UtilSP.randRangeInt(50,200) + UtilSP.randRangeInt(50,200)).toString(16);
            // this._fixedSiteRing_g[i] = new THREE.Geometry().setFromPoints(this._fixedSiteRing_p);
            // this._fixedSiteRing_mat[i] =  new THREE.LineBasicMaterial( { color: ringColor } );
            // this._fixedSiteRing_l[i] = new THREE.Line(this._fixedSiteRing_g[i], this._fixedSiteRing_mat[i])

            this._fixedSiteRing_pl[i] = new PolyLine_grp();
            this._fixedSiteRing_pl[i].points = this._fixedSiteRing_p;
            this._fixedSiteRing_pl[i].lineColor = ringColor;
            this._fixedSiteRing_pl[i].lineWidth = 3;

            this._fixedSiteDisc_grp1[i] = new THREE.Group();
            this._fixedSiteDisc_grp2[i] = new THREE.Group();
            //this._fixedSiteDisc_m[i] = new THREE.Mesh(this._fixedSiteDisc_g[i], this._fixedSiteDisc_mat[i]);

            this.add(this._fixedSiteDisc_grp1[i]);
            this._fixedSiteDisc_grp1[i].add(this._fixedSiteDisc_grp2[i]);
            this._fixedSiteDisc_grp2[i].add(this._fixedSiteRing_pl[i] );
            this._fixedSiteDiscVisible[i] = false;
            //this.add(this._fixedSiteDisc_m[i] );
        }
        this.updateFixedSites();
    }
    private updateFixedSites(){
        let discR:number;
        let zoneRadius:number = 3770;
        let i:number;
        let latRad:number;
        let longRad:number;
        let sitePos:THREE.Vector3 = new THREE.Vector3();
         for (i=0; i<this._maxFixedSites; i++){
            this._fixedSite_g[i] = new THREE.SphereGeometry(this._fixedSiteSize[i]);
            this._fixedSite_mat[i] = new THREE.MeshBasicMaterial({color:this._fixedSiteColor[i]});
            this._fixedSite_m[i].geometry = this._fixedSite_g[i];
            this._fixedSite_m[i].material = this._fixedSite_mat[i];
            latRad = UtilSP.radians(this._fixedSitesLat[i]);
            longRad = UtilSP.radians(this._fixedSitesLong[i]);
            sitePos.setFromSphericalCoords(UtilSP.earthRadiuskm + this._fixedSiteSize[i]/2, Math.PI/2 - latRad, longRad + Math.PI/2);
            
            this._fixedSite_m[i].position.x = sitePos.x;
            this._fixedSite_m[i].position.y = sitePos.y;
            this._fixedSite_m[i].position.z = sitePos.z;
            this._fixedSite_m[i].visible = this._fixedSiteVisible[i];


            discR = .83*UtilSP.earthRadiuskm;
		    //this._fixedSiteDisc_m[i].geometry = new SphericalSectionGeometry_geom({diameter:2*zoneRadius, sphereRadius:discR, nSegments:32, nRings:32, frontside:false});
            //this._fixedSiteDisc_m[i].material = new THREE.MeshPhongMaterial({color:"blue", transparent:true, opacity:0.5});
            this._fixedSiteRing_pl[i].position.x = discR;
            this._fixedSiteRing_pl[i].rotation.y = -Math.PI/2;
            this._fixedSiteDisc_grp2[i].rotation.z = latRad;
            this._fixedSiteDisc_grp1[i].rotation.y = longRad;
            this._fixedSiteRing_pl[i].visible = this._fixedSiteDiscVisible[i];
         }
    }

    public setFixedSite(iFS:number, name:string, lat_deg:number, long_deg:number, size:number, color:string, visible:boolean){
        this._fixedSitesName[iFS] = name;
        this._fixedSitesLat[iFS] = lat_deg;
        this._fixedSitesLong[iFS] = long_deg;
        this._fixedSiteColor[iFS] = color;
        this._fixedSiteSize[iFS] = size;
        this._fixedSiteVisible[iFS] = visible; 
        this.updateFixedSites();
    }
    public showFixedSiteDisc(i:number, vis:boolean){
        this._fixedSiteDiscVisible[i] = vis;   
        this.updateFixedSites();
    }

    public doEveryFrame() {
        //console.log('in doEveryFrame '+this.blinkTimer.elapsedTime);
        //this.doEveryFrame();
        if (this._siteBlink){
            let t:number = this.blinkTimer.elapsedTime;
            let v:number = UtilSP.triangleWave2(  t, 1, 0, 100, true ); // t, period, vBottom, vTop, repeating
            this.siteSphere_m.visible = (v<80) && this._showSiteSphere;
        } else {
            this.siteSphere_m.visible = this._showSiteSphere;
        }
        //console.log("vis = "+this.siteSphere_m.visible);
        //this.updateGroundTrackLine();
    } 
    public set groundTrackLon(val:number){
        this._groundTrackLon = val;
        this.updateGroundTrackLine();
    }
    public get groundTrackLon():number{
        return this._groundTrackLon;
    }     
    public set siteLong(val:number){
        this._siteLongDeg = val;
        this.updateSite();
    }
    public get siteLong():number{
        return this._siteLongDeg
    }
    public set siteLat(val:number){
        //console.log("In Earth1_grp.set siteLat = "+val);
        this._siteLatDeg = val;
        this.updateSite();
    }
    public get siteLat(){
        return this._siteLatDeg;
    }    
    public set siteBlink(val:boolean){
        this._siteBlink = val;
    }
    public get siteBlink(){
        return this._siteBlink;
    }
    public set siteColor(val:string){
        this._siteColor = val;
        this.updateSiteAppearance();
    }
    public get siteColor(){
        return this._siteColor;
    }    
    public set siteSize(val:number){
        this._siteSize = val;
        this.updateSiteAppearance();
    }
    public get siteSize(){
        return this._siteSize;
    } 

    public set beamScanAngle(val:number){
        this._beamScanAngle = val;
        this.updateSite();
    }
    public get beamScanAngle():number{
        return this._beamScanAngle
    }    

    public set showLatLines(val:boolean){
        this.latlines.visible = val;
    }
    public get showLatLines():boolean{
        return this.latlines.visible;
    }
    public set showLongLines(val:boolean){
        this.longlines.visible = val;
    }
    public get showLongLines():boolean{
        return this.longlines.visible;
    }
    public set showLatTexts(val:boolean){
        this.latTexts.visible = val;
    }
    public get showLatTexts():boolean{
        return this.latTexts.visible;
    }
    public set showLongTexts(val:boolean){
        this.longTexts.visible = val;
    }
    public get showLongTexts():boolean{
        return this.longTexts.visible;
    }

    public set showSiteSphere(val:boolean){
        this._showSiteSphere = val;
    }
    public get showSiteSphere():boolean{
        return this._showSiteSphere;
    }   
    public set latList(arr:Array<number>){
        this._latList = arr;
        this.makeLatlines();
    }
    public get latList(){
        return this._latList;
    }
    public set longList(arr:Array<number>){
        this._longList = arr;
        this.makeLonglines();
    }
    public get longList(){
        return this._longList;
    }
    public set longLineColor(val:string){
        this._longLineLineColor = val;
        this.makeLonglines();
    }
    public get longLineColor(){
        return this._longLineLineColor;
    }
    public set PMColor(val:string){
        this._primeMeridianLineColor = val;
        this.makeLonglines();
    }
    public get PMColor(){
        return this._primeMeridianLineColor;
    }
    public set latLineColor(val:string){
        this._latLineLineColor = val;
        this.makeLatlines();
    }
    public get latLineColor(){
        return this._latLineLineColor;
    }
    public set equatorColor(val:string){
        this._equatorLineColor = val;
        this.makeLatlines();
    }
    public get equatorColor(){
        return this._equatorLineColor;
    }

    public set showCursors(val:boolean){
        this.cursors.visible = val;
    }
    public get showCursors(){
        return this.cursors.visible;
    }
    public set showgroundTrackLine(val:boolean){
        this.groundTrackLine_pl.visible = val;
    }
    public get showgroundTrackLine(){
        return this.groundTrackLine_pl.visible;
    }
    public set cursorLineLineColor(val:string){
        // For backwards compatibility, force them to be the same
        this._latCursorLineLineColor = val;
        this._lonCursorLineLineColor = val;
        this.latCursor_arcline.color = this._latCursorLineLineColor;
        this.longCursor_arcline.color = this._lonCursorLineLineColor;
        //this.makeCursors();
    }
    public get cursorLineLineColor(){
        return this._latCursorLineLineColor;
    }
    public set latCursorLineLineColor(val:string){
        this._latCursorLineLineColor = val;
        this.latCursor_arcline.color = this._latCursorLineLineColor;
        //this.makeCursors();
    }
    public get latCursorLineLineColor(){
        return this._latCursorLineLineColor;
    }
    public set lonCursorLineLineColor(val:string){
        this._lonCursorLineLineColor = val;
        this.longCursor_arcline.color = this._lonCursorLineLineColor;
        //this.makeCursors();
    }
    public get lonCursorLineLineColor(){
        return this._lonCursorLineLineColor;
    }    

    public setEarthMaterial(useBitmap:boolean, color?:string){
        if (useBitmap){
            this.earth_m.material = this.earth_mat;
        } else {
            this.earth_m.material = new THREE.MeshPhongMaterial({color:UtilSP.c2rgba(color) });
        }
    }
    public set textureNo(n:number){

        switch (n){
            case 1:
                this.earth_mat.map = new THREE.TextureLoader().load( earthTexture1 );  // works
                break;
            case 2:
                this.earth_mat.map = new THREE.TextureLoader().load( earthTexture2 );  // works
                break;    
            case 3:
                this.earth_mat.map = new THREE.TextureLoader().load( earthTexture3 );  // works
                break;                  
            default:
                console.log("In Earth1_group, set  textureNo. Invalid parameter "+n);
                break;      
        }
        this.earth_m.material = this.earth_mat;
    }
    public getFixedSitePosEarthFrame(iFS):THREE.Vector3{
        let retVal:THREE.Vector3 = new THREE.Vector3();
        let latRad = UtilSP.radians(this._fixedSitesLat[iFS]);
        let longRad = UtilSP.radians(this._fixedSitesLong[iFS]);
        retVal.setFromSphericalCoords(UtilSP.earthRadiuskm, Math.PI/2 - latRad, longRad + Math.PI/2);
        return retVal;
    }
    public get fixedSitesLat():Array<number>{
        return this._fixedSitesLat;
    }
    public get fixedSitesLong():Array<number>{
        return this._fixedSitesLong;
    }
    public set showFixedSites(val:boolean){
        this._showFixedSites = val;
        for (let i:number = 0; i<this._fixedSiteVisible.length; i++){
            this._fixedSiteVisible[i] = val;    
        }
        this.updateFixedSites();
    }
    public set showBeam(val:boolean){
        //this.beamHolderAz.visible = val;
        this.beam1.visible = val;
        this.beam2.visible = val;        
    }
    public get showBeam():boolean{
        return this.beamHolderAz.visible;
    }    
    public set beamStyle(val:string){
        this._beamStyle; // "cone" "disc"
        if (val == "cone"){
            this.beam1.visible = true;
            this.beam2.visible = false;
            this._beamStyle = val;
        } else {
            this.beam1.visible = false;
            this.beam2.visible = true;       
            this._beamStyle = val;
        }
    }
    public get beamStyle(){
        return this._beamStyle;
    }
    public set showBeamContourLines(val:boolean){
        this._showBeamContourLines = val;
        this.updateBeam();
    }
    public get showBeamContourLines(){
        return this._showBeamContourLines;
    }

    public set showBeamDiscs(val:boolean){
        this._showBeamDiscs = val;
        this.updateBeam();
    }
    public get showBeamDiscs(){
        return this._showBeamDiscs;
    }
    public set beam_El_over_Az_BW_ratio(val:number){
        this._beam_El_over_Az_BW_ratio = val;
        this.updateBeam();
    }
    public get beam_El_over_Az_BW_ratio(){
        return this._beam_El_over_Az_BW_ratio;
    }

    public set beamAz(val:number){
        this._beamAz = val;
        this.updateSite();        
    }
    public get beamAz(){
        return this._beamAz;
    }
    public set beamEl(val:number){
        this._beamEl = val;
        this.updateSite();        
    }
    public get beamEl(){
        return this._beamEl;
    }
    
    public set beamLength_km(val:number){
        this._beamLength_km = val;
        this.updateBeam();        
    }
    public get beamLength_km(){
        return this._beamLength_km;
    }    
}
